import { takeEvery, select, put, call } from 'redux-saga/effects';
import service from '../../services';
import { setBookmarksInfo } from "../API/actions";
import { API_GET_BOOKMARKS_INFO } from '../../constants/API';
import { chooseServiceGenerator } from "./utils";


function* doGetBkmInfo() {
  const {token} = yield select(state => state.API);

  try {
    const {data} = yield call(() => service.getBkmsInfo(token));
    yield put(setBookmarksInfo(data))
  } catch (e) {

  }
}

export default function* () {
  yield takeEvery(API_GET_BOOKMARKS_INFO, chooseServiceGenerator,
    {fn: doGetBkmInfo, args: []},
    {fn: () => null, args: []}
  )
}